// Snabbval för antal på produktsidan. Se snippets/vk-quantity-presets.liquid.
//
// Sätter värdet i temats eget antalsfält och skickar 'change', så att
// QuantityInput (global.js) validerar min/max/steg som vanligt. I varukorgen
// fångar CartItems (cart.js) samma händelse och uppdaterar raden.
// Skriptet körs igen när snabbköpsfönstret öppnas – därav kontrollen.

if (!customElements.get('quantity-presets')) {
  customElements.define(
    'quantity-presets',
    class QuantityPresets extends HTMLElement {
      connectedCallback() {
        // Produktsidan/snabbköp: .product-form__quantity. Varukorgen: .cart-item__quantity.
        this.input = this.closest('.product-form__quantity, .cart-item__quantity')?.querySelector('input.quantity__input');
        if (!this.input) return;

        this.buttons = [...this.querySelectorAll('[data-qty]')];
        this.totalEl = this.querySelector('[data-total]');
        this.hintEl = this.querySelector('[data-hint]');
        this.price = parseInt(this.dataset.price, 10);
        if (this.totalEl) {
          // Hela kronor utan decimaler, annars alltid två ("2 686,50 kr", inte "2 686,5 kr").
          const format = (digits) =>
            new Intl.NumberFormat(this.dataset.locale, {
              style: 'currency',
              currency: this.dataset.currency,
              minimumFractionDigits: digits,
              maximumFractionDigits: digits,
            });
          const whole = format(0);
          const cents = format(2);
          this.money = { format: (value) => (Number.isInteger(value) ? whole : cents).format(value) };
        }

        this.buttons.forEach((button) =>
          button.addEventListener('click', () => this.choose(parseInt(button.dataset.qty, 10)))
        );
        this.onInput = () => this.render();
        this.input.addEventListener('change', this.onInput);
        this.input.addEventListener('input', this.onInput);

        // Priset följer vald variant (t.ex. VHS 249 kr / S-VHS 299 kr).
        if (this.totalEl && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          const ownSection = this.dataset.section.replace(/^quickadd-/, '');
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId.replace(/^quickadd-/, '') !== ownSection) return;
            if (event.data.variant) this.price = event.data.variant.price;
            this.render();
          });
        }

        this.render();
      }

      disconnectedCallback() {
        this.input?.removeEventListener('change', this.onInput);
        this.input?.removeEventListener('input', this.onInput);
        if (this.unsubscribe) this.unsubscribe();
      }

      choose(qty) {
        const min = parseInt(this.input.dataset.min || this.input.min || '1', 10);
        const max = this.input.dataset.max ? parseInt(this.input.dataset.max, 10) : null;
        const step = parseInt(this.input.step || '1', 10);
        let value = Math.max(min, qty);
        if (max !== null) value = Math.min(max, value);
        value = Math.round(value / step) * step || step;

        this.input.value = value;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      render() {
        const qty = parseInt(this.input.value, 10) || 0;

        this.buttons.forEach((button) =>
          button.setAttribute('aria-pressed', String(parseInt(button.dataset.qty, 10) === qty))
        );

        // Rabattsteg "antal:procent,…" – bara satta där rabatten är verifierad.
        const tiers = (this.dataset.tiers || '')
          .split(',')
          .filter(Boolean)
          .map((pair) => pair.split(':').map(Number))
          .map(([min, pct]) => ({ min, pct }));
        const current = [...tiers].reverse().find((tier) => qty >= tier.min);
        const next = tiers.find((tier) => qty < tier.min);

        if (this.totalEl && this.money && this.price >= 0) {
          const full = (this.price * qty) / 100;
          let text = `${this.dataset.totalLabel}: ${this.money.format(full)}`;
          if (current) {
            const discounted = Math.round(full * (100 - current.pct)) / 100;
            text = `${this.dataset.totalLabel}: ${this.money.format(discounted)} (${this.money.format(full)} ${this.dataset.beforeDiscount})`;
          }
          this.totalEl.textContent = text;
        }

        if (this.hintEl) {
          const goal = parseInt(this.dataset.freeBox, 10);
          const done = qty >= goal;
          let text;
          if (tiers.length) {
            text = current
              ? this.dataset.hintDone.replace('[pct]', current.pct) +
                (next ? this.dataset.hintNext.replace('[pct]', next.pct).replace('[min]', next.min) : '')
              : this.dataset.hintLeft.replace('[n]', next.min - qty).replace('[pct]', next.pct);
          } else {
            text = done ? this.dataset.hintDone : this.dataset.hintLeft.replace('[n]', goal - qty);
          }
          this.hintEl.textContent = text;
          this.hintEl.classList.toggle('quantity-presets__hint--done', done);
        }
      }
    }
  );
}
